module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('wxc-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.show && _vm.hasOverlay,
      "can-auto-close": _vm.overlayCanClose,
      "opacity": _vm.opacity,
      "data-evt-wxcOverlayBodyClicking": "",
      "data-evt-wxcOverlayBodyClicked": ""
    },
    on: {
      "wxcOverlayBodyClicking": _vm.wxcOverlayBodyClicking,
      "wxcOverlayBodyClicked": _vm.wxcOverlayBodyClicked
    }
  }, 'wxc-overlay', _vm.mergeOverlayCfg, false)) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "wxc-mask",
    staticClass: "wxc-mask weex-ct weex-div",
    style: (_vm._px2rem(_vm.maskStyle, 75)),
    attrs: {
      "hack": _vm.shouldShow,
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.contentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "mask-bottom weex-ct weex-div",
    style: ({
      width: _vm._px2rem(_vm.width + 'px', 75)
    }),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeIconClicked($event)
      }
    }
  }, [_c('figure', {
    staticClass: "mask-close-icon weex-el weex-image",
    attrs: {
      "src": _vm.closeIcon,
      "aria-label": "关闭",
      "data-img-src": _vm.closeIcon,
      "weex-type": "image"
    }
  })]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec13b7fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec13b7fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-mask/index.vue
// module id = 247
// module chunks = 0 1